import { Component, OnInit } from '@angular/core';
import { UntypedFormBuilder, FormControl, UntypedFormGroup, Validators, NgForm } from '@angular/forms';
import { Router, ActivatedRoute } from "@angular/router"
import { NzMessageService } from 'ng-zorro-antd/message';
import { AuthService } from '../services/auth.service';
import { Login } from '../login/login';
import{ BehaviorSubject} from'rxjs';

@Component({
    selector: 'app-reset-password',
    templateUrl: './reset-password.component.html',
    styleUrls: ['./reset-password.component.css'],
    standalone: false
})
export class ResetPasswordComponent implements OnInit {
  validateForm!: UntypedFormGroup;

  private loggedIn= new BehaviorSubject<boolean>(false);
  
  constructor(   
    private fb: UntypedFormBuilder,
    private route: ActivatedRoute,
    private router: Router,
    private message: NzMessageService,
    private authService: AuthService) { }

    submitForm(): void {
      for (const i in this.validateForm.controls) {
        this.validateForm.controls[i].markAsDirty();
        this.validateForm.controls[i].updateValueAndValidity();
      }
  
      if(this.validateForm.valid){
        let id = this.message.loading('enviando email...').messageId;
        this.authService.resetPasswordSendEmail(this.validateForm.value).subscribe((l: any) => {
          this.router.navigate(['/login']);
          this.message.remove(id);
          this.message.success('Foi enviado ao seu e-mail as instruções para redefinição de senha!');
        }, (err: any) => {
          this.message.remove(id);
          this.message.error('Houve uma falha ao tentar enviar o e-mail, tente novamente mais tarde!');
        });
      }
    }

    ngOnInit(): void {
      this.validateForm = this.fb.group({
        email: [null, [Validators.email, Validators.required]],
      });
    }

}
